import { Component, OnInit } from '@angular/core';
import { EquipmentService } from '../../../services/equipment/equipment.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-equipment',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './equipment.component.html',
  styleUrl: './equipment.component.scss'
})
export class EquipmentComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {
  }
}
